export default __webpack_public_path__ + "static/media/Resume-Chukwuka Chimdindu Emmanuel.c82079ad.pdf";